//US ENGLISH

const spanishTranslations = {
  helloWorld: "Hola Mundo",
  changeLocale: "Cambiar configuración regional",
  changeTheme: "Cambiar tema",
};

export default spanishTranslations;